import { useMutation } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useCallback, useState } from 'react';

import { ActivateOtpSecretDocument } from '~/graphql/generated/graphql';
import { twoFactorAuthModalState } from '~/state/layouts/SharedAppShell/atoms';

import { Fields } from './types';

export const useActivateOtpSecret = () => {
  const [{ otpSecretId }, setTwoFactorAuthModalState] = useAtom(twoFactorAuthModalState);

  const [isActivating, setIsActivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [activate] = useMutation(ActivateOtpSecretDocument);

  const handleSubmit = useCallback(
    async (values: Fields) => {
      if (!otpSecretId) return;

      setIsActivating(true);
      setError(null);

      try {
        await activate({
          variables: {
            input: {
              practitionerOtpSecretId: otpSecretId,
              onetimeCode: `${values.onetimeCode}`,
            },
          },
        });
        setTwoFactorAuthModalState((_state) => ({ ..._state, currentPanel: 'completed' }));
      } catch (_error) {
        setError(_error?.message || 'エラーが発生しました');
      }
      setIsActivating(false);
    },
    [otpSecretId, activate, setTwoFactorAuthModalState],
  );

  return {
    activating: isActivating,
    error,
    handleSubmit,
  };
};
